import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";

type CreateTradeBody = components["schemas"]["CreateTradeBody"];
type TradeResponse = components["schemas"]["TradeResponse"];

export function useCreateTrade() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TradeResponse, Error, CreateTradeBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/trades", { body });
      if (error !== undefined) {
        throw new Error("Failed to create trade");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRADES_QUERY_KEY });
    },
  });
}
